import request from "../request";

/**
 * Состояние корзины
 * @return {Promise}
 */
export const count = () => {
	return request({
		url: "/cart/count",
		type: "GET",
		needOverlay: false,
	});
};

/**
 * Позиции в корзине
 * @return {Promise}
 */
export const getCart = () => {
	return request({
		url: "/cart/get-cart",
		type: "GET",
		needOverlay: false,
	});
};

export const checkExpectedOrders = () => {
	return request({
		url: "/cart/check-expected-orders",
		type: "GET",
	})
}

